export const getGender = (pesel) => {
  return parseInt(pesel.substring(9, 10), 10) % 2 === 1 ? 1 : 2
}

export const getDateOfBirth = (peselString) => {
  const pesel = [...peselString].map(Number)
  const day = pesel[4] * 10 + pesel[5]
  const month = ((pesel[2] % 2) * 10 + pesel[3])

  let year = 1900 + pesel[0] * 10 + pesel[1]

  if (pesel[2] >= 2 && pesel[2] < 8) { year += Math.floor(pesel[2] / 2) * 100 }
  if (pesel[2] >= 8) { year -= 100 }

  return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
}
